<div class="row">
    <div class="col-md-4">
        <ul class="nav nav-pills nav-stacked">
            <li class="nav-item" *ngFor="let category of toDoCategoryConfiguration" role="presentation">
                <a *ngIf="category.display" class="nav-link" [ngClass]="isActiveCategory(category)" (click)="switchCategoryDisplay(category.toDoType)">{{category.screenDisplay}}
                    <span class="badge" [ngClass]="getBadgeClass(category.severity, category.count)">{{category.count}}
                        <span class="fa fa-plus" *ngIf="displayIcon(category)">
                            </span>
                        </span>
                </a>
            </li>
        </ul>
    </div>
    <div class="col-md-8 table-responsive" style="max-height: 400px;">
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th>Desc</th>
                <th>Due Date</th>
                <th>Owner</th>
                <th>OU</th>
            </tr>
            </thead>
            <tbody *ngIf="activeCategory">
            <tr *ngFor="let item of activeCategory.result" (click)="selectItem(item)">
                <td>{{item.description}}</td>
                <td>{{item.dueDate | date:'longDate'}}</td>
                <td>{{item.userName}}</td>
                <td>{{item.orgUnitName}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="row">
    <div class="col-md-4">
        <ul class="nav nav-pills nav-stacked">

        </ul>
    </div>
    <div class="col-md-8" *ngIf="activeCategory">
        <a (click)="showMore(activeCategory.toDoType)" *ngIf="displayIcon(activeCategory)" ><p class="text-center"> Load More... </p></a>
    </div>
</div>